import React from "react";

export default function Test() {
  React.useEffect(() => {}, []);

  return (
    <div>
      <h1>TEST</h1>
    </div>
  );
}
